import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';

type PageTitleProps = PropsWithChildren<{
  className?: string;
  title: string;
}>;

export function PageTitle({ children, title, className }: PageTitleProps) {
  return (
    <div className={classNames('flex justify-between pb-2', className)}>
      <h1 className="text-3xl font-semibold tracking-tight text-dl-text">
        {title}
      </h1>
      {children}
    </div>
  );
}
